var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container-full flex-col"},[_c('about-us-header'),_c('partners',{attrs:{"text":true}}),_c('our-values'),_c('in-numbers'),_c('achievements'),_c('cta'),_c('our-team'),_c('faq')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }